/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Hero_Cta2Inputs */

const en_st_hero_cta2 = /** @type {(inputs: St_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See pricing`)
};

const id_st_hero_cta2 = /** @type {(inputs: St_Hero_Cta2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat harga`)
};

/**
* | output |
* | --- |
* | "See pricing" |
*
* @param {St_Hero_Cta2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_hero_cta2 = /** @type {((inputs?: St_Hero_Cta2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Hero_Cta2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_hero_cta2(inputs)
	return en_st_hero_cta2(inputs)
});